import { defineComponent as _defineComponent } from 'vue'
import { ImageEffectPreset } from '@/components/DesignStudio/ImageEffectsProperties/types/presets';
import { computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

interface Props {
    preset?: ImageEffectPreset
    isFree?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ApiKeyRequirementFooter',
  props: {
    preset: null,
    isFree: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    preset?: ImageEffectPreset
    isFree?: boolean
};



const shouldShowMessage = computed(() => {
    return props.preset !== undefined
        ? !props.preset?.isFree
        : !props.isFree;
});

return { __sfc: true,props, shouldShowMessage, FontAwesomeIcon }
}

})